var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14509",
    "data-name": "Rectangle 14509",
    width: 22.28,
    height: 17.247,
    fill: "#1228f3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discord",
    transform: "translate(-0.17 -0.205)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14510",
    "data-name": "Rectangle 14510",
    width: 35,
    height: 37,
    rx: 6,
    transform: "translate(0.17 0.205)",
    fill: "#1228f3",
    opacity: 0.144
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40303",
    "data-name": "Group 40303",
    transform: "translate(6.909 10.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40302",
    "data-name": "Group 40302",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65321",
    "data-name": "Path 65321",
    d: "M18.873,1.444A18.147,18.147,0,0,0,14.276,0a13.478,13.478,0,0,0-.589,1.222,16.876,16.876,0,0,0-5.094,0A13.071,13.071,0,0,0,8,0,18.086,18.086,0,0,0,3.4,1.448a19.277,19.277,0,0,0-3.3,12.908,18.377,18.377,0,0,0,5.637,2.889,14.02,14.02,0,0,0,1.207-1.988,11.874,11.874,0,0,1-1.9-.925c.159-.118.315-.242.466-.369a12.991,12.991,0,0,0,11.271,0c.152.127.308.251.466.369a11.841,11.841,0,0,1-1.9.927,13.958,13.958,0,0,0,1.207,1.988,18.339,18.339,0,0,0,5.641-2.891A19.258,19.258,0,0,0,18.873,1.444M7.438,11.757a2.163,2.163,0,0,1-2-2.278,2.151,2.151,0,0,1,2-2.28,2.137,2.137,0,0,1,2,2.28,2.148,2.148,0,0,1-2,2.278m7.4,0a2.163,2.163,0,0,1-2-2.278,2.151,2.151,0,0,1,2-2.28,2.137,2.137,0,0,1,2,2.28,2.15,2.15,0,0,1-2,2.278",
    transform: "translate(0)",
    fill: "#1228f3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.f615b56cde269a1cdfe83cfcfdff27b3.svg";
export { ForwardRef as ReactComponent };